<template>
    <div class="home-swiper">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,i) in items" :key="i">
                    <div class="swiper-slide__img-holder">
                        <!-- <img :src="item.src" alt=""> -->
                        <v-img :src="item.src" contain></v-img>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";
    export default {
        name: "Carousel",
        data() {
            return {
                items: [{
                       src: require('../assets/myphone_shop_banner_1.jpeg')
                    },
                    {
                        src: require('../assets/myphone_shop_banner_2.jpeg')
                    },
                    {
                        src: require('../assets/myphone_shop_banner_3.jpeg')
                    },
                ]
            }
        },
        props: {
            msg: String
        },
        methods: {},
        mounted() {
            let swiper = new Swiper(".swiper-container", {
                slidesPerView: 1,
                // spaceBetween: 16,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        }
    };

</script>

<style lang="scss">
    .home-swiper {
        position: relative;
        padding: 0;
        margin: 0;

        .swiper-container {
            width: 100%;
            height: 100%;
            // padding-bottom: .65rem;
            // padding-bottom: 1.2rem;
        }

        .swiper-slide {
            .swiper-slide__img-holder {
                width: 100%;

                img {
                    object-fit: contain;
                    max-width: 100%;
                    height: auto;
                }
            }
        }
    }

    .swiper-pagination-bullet {
        width: 5px;
        height: 5px;
        bottom: 10px;
    }

    .swiper-pagination-bullet-active {
        background: #f9690e;
    }

</style>
